module.exports = __webpack_public_path__ + "img/2037267381.db1497a6.gif";